import { useMemo } from 'react'
import { dateISOToDateAndTime } from 'Data/format.js'
import { utcToZonedTime } from 'date-fns-tz'
import { formatTzDate } from 'Data/format.js'
import { useDataValue } from 'Simple/Data.js'
import {
  getType,
  getAlertValue,
  getPersonFullName,
  getTimestamp,
  getValue,
} from './helpers.js'
import { DEFAULT_TIMEZONE } from 'Data/constants.js'

export default function useDataTransform(props, data) {
  let patient = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
  })

  let time_zone_id =
    useDataValue({
      viewPath: props.viewPath,
      context: 'global',
      path: 'current_location.time_zone_id',
    }) || DEFAULT_TIMEZONE

  return useMemo(() => {
    if (!data) return data

    let medical_alerts = data.medical_histories_questions
      .filter(
        question =>
          (question.category !== 'habits' && question.category !== 'general') ||
          question.type === 'boolean'
      )
      .flatMap(question => {
        let answer = question.answers[0]
        let response = answer?.value ?? ''

        let alert = getAlertValue({
          answer_alert: answer?.alert,
          answer_value: response,
          alert_type: question?.alert_type,
          alert_conditions: question?.alert_conditions,
        })

        let created_at = formatTzDate(
          utcToZonedTime(`${answer?.created_at}Z`, time_zone_id),
          'M/dd/y h:mm b',
          time_zone_id
        )
        return {
          id: question.id,
          name: question.name,
          type: getType(question),
          createdByPerson: getPersonFullName(answer?.patient?.person),
          createdDate: created_at,
          lastModified: created_at,
          timestamp: getTimestamp(created_at),
          createdFrom: 0,
          alert,
          value: getValue({
            response,
            questionType: question.type,
            answerAlertValue: answer?.alert,
            answerAlert: alert,
          }),
        }
      })
      .filter(alertDTO => alertDTO.alert === true)

    let notes = data.vaxiom_notes
      .flatMap(item => {
        let { note = '' } = item ?? {}

        let created_at = formatTzDate(
          utcToZonedTime(`${item?.sys_created}Z`, time_zone_id),
          'M/dd/y h:mm b',
          time_zone_id
        )

        return {
          id: item.id,
          name: note,
          type: getType(item),
          createdByPerson: getPersonFullName(item?.author_user?.person),
          createdDate: created_at,
          lastModified: created_at,
          timestamp: getTimestamp(created_at),
          createdFrom: 0,
          alert: item.alert,
        }
      })
      .filter(noteDTO => noteDTO.alert === true)

    return [...medical_alerts, ...notes].sort(
      (a, b) => b.timestamp - a.timestamp
    )
  }, [data, patient])
}
